import { createStore, applyMiddleware, combineReducers } from 'redux';
import ReduxThunk from "redux-thunk";
import {  appReducer } from "./reducer/app.reducer";
//import { reducer as reduxFormReducer } from 'redux-form';

// const combiner = combineReducers({
//     appReducer:appReducer
// });

export const store = createStore(appReducer, applyMiddleware(ReduxThunk));